import { getMessagingInstance } from "./messaging";

export const initFirebaseMessaging = async (): Promise<string | null> => {
  console.log("🚀 Lancement de initFirebaseMessaging");

  const messaging = await getMessagingInstance();
  if (!messaging) {
    console.log("🔕 Messagerie non supportée, initialisation annulée.");
    return null;
  }

  try {
    console.log("🔧 Tentative d'enregistrement du service worker...");
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", { scope: "/" });
    console.log("✅ Service worker enregistré avec le scope :", registration.scope);

    const hasNotificationApi = typeof Notification !== "undefined";
    console.log("🔎 Vérification des permissions : ", hasNotificationApi ? Notification.permission : "unavailable");

    const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;

    const { getToken } = await import("firebase/messaging");
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });

    if (token) {
      console.log("🎯 Token FCM :", token);
      return token;
    }

    console.warn("⚠️ Aucun token reçu (getToken a retourné null). L'utilisateur a peut-être refusé la permission.");
    return null;
  } catch (error) {
    console.error("❌ Erreur dans initFirebaseMessaging :", error);
    return null;
  }
};
